export default __webpack_public_path__ + "static/media/car-light.15806886.png";